import { useEffect, useState } from "react";
import { getRequest } from "../components/apiRequests/requestApi";

export function useSearchPlayer(username) {
  const [playerDetails, setPlayerDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!username) return;

    const fetchUser = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await getRequest(`/search?q=${username}`);
        const user = response.data;
        setPlayerDetails(user);
      } catch (err) {
        console.error("Search error:", err);
        setError(err.message || "Failed to fetch user");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [username]);

  return { playerDetails, loading, error };
}
